(function () {
  const mega = document.getElementById('ll-mega-menu');
  const shopToggle = document.querySelector('[data-ll-mega-toggle]');

  if (mega && shopToggle) {
    const triggers = mega.querySelectorAll('[data-ll-mega-panel]');
    const panels = mega.querySelectorAll('[data-ll-mega-panel-target]');
    let closeTimer;

    function cancelClose() {
      window.clearTimeout(closeTimer);
    }

    function openMega() {
      cancelClose();
      mega.classList.add('is-open');
      shopToggle.setAttribute('aria-expanded', 'true');
      if (!mega.querySelector('.ll-mega__trigger.is-active')) {
        activatePanel(triggers[0]?.dataset.llMegaPanel);
      }
    }

    function closeMega() {
      cancelClose();
      mega.classList.remove('is-open');
      shopToggle.setAttribute('aria-expanded', 'false');
    }

    function scheduleClose() {
      cancelClose();
      closeTimer = window.setTimeout(closeMega, 150);
    }

    function activatePanel(id) {
      if (!id) return;
      triggers.forEach((t) => t.classList.toggle('is-active', t.dataset.llMegaPanel === id));
      panels.forEach((p) => {
        const on = p.dataset.llMegaPanelTarget === id;
        p.classList.toggle('is-active', on);
        // Lazy images inside display:none never fetch; force load when panel opens
        if (on) {
          p.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            img.loading = 'eager';
            if (!img.complete) {
              const { src } = img;
              img.src = src;
            }
          });
        }
      });
    }

    function focusWithinMegaOrToggle() {
      const active = document.activeElement;
      return !!(active && (mega.contains(active) || shopToggle.contains(active)));
    }

    shopToggle.addEventListener('click', (e) => {
      e.preventDefault();
      if (mega.classList.contains('is-open')) {
        closeMega();
      } else {
        openMega();
      }
    });
    shopToggle.addEventListener('mouseenter', openMega);
    shopToggle.addEventListener('mouseleave', scheduleClose);
    shopToggle.addEventListener('focus', openMega);
    mega.addEventListener('mouseenter', cancelClose);
    mega.addEventListener('mouseleave', scheduleClose);
    mega.addEventListener('focusin', cancelClose);

    [shopToggle, mega].forEach((el) => {
      el.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!focusWithinMegaOrToggle()) closeMega();
        });
      });
    });

    triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => activatePanel(trigger.dataset.llMegaPanel));
      trigger.addEventListener('focus', () => activatePanel(trigger.dataset.llMegaPanel));
      trigger.addEventListener('click', (event) => {
        activatePanel(trigger.dataset.llMegaPanel);
        if (trigger.tagName === 'A' && trigger.getAttribute('href')) return;
        event.preventDefault();
      });
    });

    document.addEventListener('click', (e) => {
      if (!mega.classList.contains('is-open')) return;
      const inside = mega.contains(e.target) || shopToggle.contains(e.target);
      if (!inside) closeMega();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !mega.classList.contains('is-open')) return;
      closeMega();
      shopToggle.focus();
    });
  }

  /* Tablet: only one overlay open at a time (drawer vs search) */
  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  const headerDrawer = document.querySelector('header-drawer');
  const searchModal = document.querySelector('details-modal.header__search');
  const searchDetails = searchModal?.querySelector('details');
  const tabletQuery = window.matchMedia('(min-width: 750px) and (max-width: 989px)');

  let navLockY = 0;

  function headerLockHeight() {
    const header = document.querySelector('.section-header');
    if (!header) return 57;
    return Math.max(1, Math.floor(header.getBoundingClientRect().height || header.offsetHeight || 57));
  }

  function syncDrawerTop() {
    const height = headerLockHeight();
    document.documentElement.style.setProperty('--ll-header-lock-height', `${height}px`);
    document.documentElement.style.setProperty('--header-bottom-position', `${height}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }

  function lockNavScroll() {
    if (document.documentElement.classList.contains('ll-nav-locked')) return;
    navLockY = window.scrollY || window.pageYOffset;
    syncDrawerTop();
    document.documentElement.classList.add('ll-nav-locked');
    document.body.style.top = `-${navLockY}px`;
    requestAnimationFrame(() => {
      syncDrawerTop();
      window.setTimeout(syncDrawerTop, 0);
    });
  }

  function unlockNavScroll() {
    if (!document.documentElement.classList.contains('ll-nav-locked')) return;
    document.documentElement.classList.remove('ll-nav-locked');
    document.documentElement.style.removeProperty('--ll-header-lock-height');
    document.body.style.top = '';
    window.scrollTo(0, navLockY);
  }

  if (drawerDetails) {
    new MutationObserver(() => {
      if (drawerDetails.hasAttribute('open')) lockNavScroll();
      else unlockNavScroll();
    }).observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
  }

  function isTablet() {
    return tabletQuery.matches;
  }

  function closeDrawer() {
    if (!headerDrawer || !drawerDetails?.hasAttribute('open')) return;
    const summary = drawerDetails.querySelector('summary');
    headerDrawer.closeMenuDrawer(new Event('close'), summary);
    document.querySelector('.section-header')?.classList.remove('menu-open');
  }

  function closeSearch() {
    searchModal?.close(false);
  }

  const drawerSummary = drawerDetails?.querySelector(':scope > summary');
  const searchSummary = searchDetails?.querySelector(':scope > summary');

  drawerSummary?.addEventListener(
    'click',
    () => {
      if (isTablet() && searchDetails?.open) closeSearch();
    },
    true,
  );

  searchSummary?.addEventListener(
    'click',
    () => {
      if (isTablet() && drawerDetails?.open) closeDrawer();
    },
    true,
  );
})();
